import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const userData = localStorage.getItem("user");
  return userData ? children : <Navigate to="/" />;
}

export default PrivateRoute;
